// extracted by mini-css-extract-plugin
export default {"main-view":"Restaurants_main-view__fX76u","main-sub-view":"Restaurants_main-sub-view__wHybI"};